import { ComponentProps } from 'react';
import './style.scss';
import AntdModal from 'antd/es/modal';
import ModalClose from '@/assets/svgFile/ModalClose';

export default function Modal(props: ComponentProps<typeof AntdModal>) {
    return <AntdModal cancelButtonProps={{ size: 'large' }} okButtonProps={{ size: 'large' }} closeIcon={<ModalClose />} {...props} />;
}
